@file:OptIn(InternalResourceApi::class)

package dentalcrm.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dentalcrm.composeapp.generated.resources/"

@delegate:ResourceContentHash(-200_505_136)
internal val Res.font.IndieFlower_Regular: FontResource by lazy {
      FontResource("font:IndieFlower_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/IndieFlower-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_236_316_748)
internal val Res.font.inter_black: FontResource by lazy {
      FontResource("font:inter_black", setOf(
        ResourceItem(setOf(), "${MD}font/inter_black.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-146_124_937)
internal val Res.font.inter_bold: FontResource by lazy {
      FontResource("font:inter_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(309_378_273)
internal val Res.font.inter_extra_bold: FontResource by lazy {
      FontResource("font:inter_extra_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_extra_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-662_168_346)
internal val Res.font.inter_extra_light: FontResource by lazy {
      FontResource("font:inter_extra_light", setOf(
        ResourceItem(setOf(), "${MD}font/inter_extra_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(585_760_695)
internal val Res.font.inter_light: FontResource by lazy {
      FontResource("font:inter_light", setOf(
        ResourceItem(setOf(), "${MD}font/inter_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-456_192_601)
internal val Res.font.inter_medium: FontResource by lazy {
      FontResource("font:inter_medium", setOf(
        ResourceItem(setOf(), "${MD}font/inter_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_183_800_182)
internal val Res.font.inter_regular: FontResource by lazy {
      FontResource("font:inter_regular", setOf(
        ResourceItem(setOf(), "${MD}font/inter_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_511_093_583)
internal val Res.font.inter_semi_bold: FontResource by lazy {
      FontResource("font:inter_semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_semi_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-240_546_778)
internal val Res.font.inter_thin: FontResource by lazy {
      FontResource("font:inter_thin", setOf(
        ResourceItem(setOf(), "${MD}font/inter_thin.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("IndieFlower_Regular", Res.font.IndieFlower_Regular)
  map.put("inter_black", Res.font.inter_black)
  map.put("inter_bold", Res.font.inter_bold)
  map.put("inter_extra_bold", Res.font.inter_extra_bold)
  map.put("inter_extra_light", Res.font.inter_extra_light)
  map.put("inter_light", Res.font.inter_light)
  map.put("inter_medium", Res.font.inter_medium)
  map.put("inter_regular", Res.font.inter_regular)
  map.put("inter_semi_bold", Res.font.inter_semi_bold)
  map.put("inter_thin", Res.font.inter_thin)
}
